module.exports = __webpack_public_path__ + "static/media/gangbot-2.90b37c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gangbot/gangbot-2.jpg
// module id = 195
// module chunks = 0